import { createElementBlock as o, openBlock as r, createElementVNode as l } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function a(n, e) {
  return r(), o("svg", t, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.75 4.5a.75.75 0 0 0 0 1.5h.309C14.13 6 15 6.87 15 7.941v4.809A2.25 2.25 0 0 1 12.75 15H4.575c.347-1.712 1.86-3 3.675-3H12v.75a.75.75 0 0 0 1.5 0v-1.518a.73.73 0 0 0-.732-.732H8.25C5.605 10.5 3.364 12.456 3 15v1.5h.825a3.751 3.751 0 0 0 7.35 0h1.65a3.751 3.751 0 0 0 7.35 0H21v-2.25a3 3 0 0 0-3-3h-1.5V7.412A2.91 2.91 0 0 0 13.588 4.5zM19.5 15v-.45a1.5 1.5 0 0 0-1.5-1.5h-1.512A3.73 3.73 0 0 1 15.75 15zm-.878 1.5a2.251 2.251 0 0 1-4.244 0zm-9 0H5.378a2.25 2.25 0 0 0 4.244 0",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M18 6.75a.75.75 0 0 0-.75.75V9a.75.75 0 0 0 1.5 0V7.5a.75.75 0 0 0-.75-.75M6.75 8.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
    }, null, -1)
  ])]);
}
const d = { render: a };
export {
  d as default,
  a as render
};
